import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue'
import { Icons } from '@/icons/icons'


export default /*#__PURE__*/_defineComponent({
  __name: 'LfBlueTitleComponent',
  props: {
  title: {
    type: String as PropType<string>,
    required: true
  },
  showClose: {
    type: Boolean as PropType<boolean>,
    default: false
  }
},
  emits: ['close'],
  setup(__props, { emit }) {

const props = __props;

const closeIcon = Icons.CLOSE



// EVENTS


function close() {
  emit('close')
}

return { __sfc: true,closeIcon, props, emit, close }
}

})